import { get } from 'lodash';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';
import { ButtonInLink } from '@hivebrite/design-system/ButtonInLink';
import { useScrollTop } from '@hivebrite/react-hooks';

import SuccessConfetti from 'hb-react/frontoffice/components/SuccessConfetti';
import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import Layout from 'hb-react/shared/apps/Events/components/Layout/';
import { useEventCartContext } from 'hb-react/shared/apps/Events/contexts/EventCartContext';
import { useEventContext } from 'hb-react/shared/apps/Events/contexts/EventContext';

import SuccessMessage from './SuccessMessage';
import SuccessWithUpdateUserModal from './SuccessWithUpdateUserModal';
import EventRegistrationSidebar from '../EventRegistrationSidebar';

const SuccessContent = ({ event }) => {
  const { eventDetailsPageLink } = useEventContext();
  const { currentNetwork, currentUser } = useDefaultAppContexts();

  const displayConfetti = get(
    currentNetwork,
    'network_config.confetti_on_reg_success',
    false,
  );

  return (
    <>
      {displayConfetti && <SuccessConfetti duration={3000} />}
      <Layout
        sidebar={
          event && <EventRegistrationSidebar event={event} withShoppingCard />
        }
      >
        {event && (
          <Box flexDirection="column">
            <SuccessMessage
              selectedMediaIcons={event?.social_media_list}
              headline={event?.success_page?.headline}
              tagline={event?.success_page?.tagline}
              successPageContent={event?.success_page?.success_page}
              sharingParameters={{
                title: event.title,
                url: `${window.location.origin}${Routes.networks_event_path(
                  event.id,
                )}`,
              }}
            />
            <Box pt={5}>
              {currentUser && (
                <Box mr={5}>
                  <ButtonInLink
                    linkProps={{
                      to: Routes.user_my_events_path(currentUser),
                    }}
                  >
                    {__('See your events')}
                  </ButtonInLink>
                </Box>
              )}
              <Button
                onClick={() => (window.location.href = eventDetailsPageLink)}
                variant="secondary"
              >
                {__('See event detail page')}
              </Button>
            </Box>
          </Box>
        )}
      </Layout>
    </>
  );
};

const EventCompleteControl = ({ children }) => {
  const navigate = useNavigate();
  const { eventDetailsPageLink } = useEventContext();
  const { setOrderCompleted, data } = useEventCartContext();

  useEffect(() => {
    if (!data) {
      navigate(eventDetailsPageLink);
    } else {
      setOrderCompleted(true);
    }
  }, []);

  if (!data) {
    return null;
  }

  return children;
};

const EventSuccessContainer = () => {
  const { event } = useEventContext();

  useScrollTop();

  return (
    <SuccessWithUpdateUserModal event={event}>
      <EventCompleteControl>
        <SuccessContent event={event} />
      </EventCompleteControl>
    </SuccessWithUpdateUserModal>
  );
};

export default EventSuccessContainer;
